<template>
  <llp-page
    id="datatable-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-2 m-lg-3">
          <div class="card-body">
            <div class="row p-0 align-items-center rental-payment">
              <div class="col mt-4 ms-lg-3 me-md-2">
                <h4 class="fee-heading">Fees By Credit Card</h4>
              </div>
              <div class="col d-flex justify-content-end">
                <llp-button
                  :load-spinner="showaddadminSpinner"
                  classNames="btn-secondary d-none d-sm-block new-btn"
                  @click="BackToServices()"
                >
                  Back To Services
                </llp-button>
                <llp-button
                  :load-spinner="showaddadminSpinner"
                  classNames="btn-secondary d-block d-sm-none new-btn"
                  @click="BackToServices()"
                >
                  Go Back
                </llp-button>
              </div>
            </div>
            <div class="col-lg-5 col-md-8 col-sm-6">
              <div v-if="loading" class="loader-overlay">
                <div class="spinner"></div>
              </div>
              <div class="card m-2 m-lg-3">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-8 col-md-8 col-sm-12 mb-2">
                      <llp-label id="amountId" :aria-label="name"
                        >Fee Amount:</llp-label
                      >
                      <llp-input
                        id="amountInput"
                        v-model="amount"
                        class="w-100"
                        autocomplete="off"
                        :errors="validatorPayment.amount.$errors"
                      >
                      </llp-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-8 col-md-8 col-sm-12 mb-2">
                      <llp-label id="name" :aria-label="name"
                        >Tutor's Name:</llp-label
                      >
                      <llp-input
                        id="mobileInput"
                        v-model="name"
                        class="w-100"
                        autocomplete="off"
                        :errors="validatorPayment.name.$errors"
                      ></llp-input>
                    </div>
                  
                 <div v-if="isUpiVerified" class="mt-2 ms-2">
  <p class="fw-bold">
    Beneficiary Name: {{ verifiedBeneficiaryName }}
  </p>
  <p class="text-success d-flex align-items-center">
    <i class="fas fa-check-circle verified-icon"></i>
    Verified UPI ID: {{ selectedUpiDetails ? selectedUpiDetails.vpa : beneficiary }}
  </p>
  <p
    @click="resetPaymentMethod"
    class="text-primary"
    style="cursor: pointer"
  >
    <i class="fas fa-exchange-alt me-2"></i>
    Change Payment Method
  </p>
</div>

<div v-if="verifiedBankUser" class="mt-2 ms-2">
  <p class="fw-bold">
    Beneficiary Name: {{ verifiedBankSummary.name }}
  </p>
  <p class="text-success d-flex align-items-center">
    <i class="fas fa-check-circle verified-icon"></i>
    Bank Account Verified - ****{{ verifiedBankSummary.accountLastFourDigits }}
  </p>
  <p
    @click="resetPaymentMethod"
    class="text-primary"
    style="cursor: pointer"
  >
    <i class="fas fa-exchange-alt me-2"></i>
    Change Payment Method
  </p>
</div>
                 
                  </div>
                  <div class="payment-details" v-if="paymentMethods">
                    <h6 class="fw-bold mt-2">Send money to your tutor</h6>
                    <p @click="showBankModalDialog()" style="cursor: pointer">
                      <span class="icon-circle"
                        ><i class="fas fa-university"></i
                      ></span>
                      Add Bank Account
                    </p>
                    <p @click="showUPIModal()" style="cursor: pointer">
                      <span class="icon-circle"
                        ><i class="fas fa-qrcode"></i
                      ></span>
                      Add BHIM UPI ID
                    </p>
                  </div>
                  <div class="row" v-if="this.paymentCharges">
                    <div class="col-6">
                      <p class="mb-1"><strong>Amount:</strong></p>
                      <p class="mb-3"><strong>Service Charge:</strong></p>
                    </div>
                    <div class="col-6">
                      <p class="mb-1">₹{{ paymentCharges.base_amount }}</p>
                      <p class="mb-3">₹{{ paymentCharges.charge_amount }}</p>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-6 col-md-8 col-sm-8">
                      <llp-button
                        classNames="btn-secondary"
                        :loadSpinner="showLoginSpinner"
                        @click="PaywithCreditCard()"
                      >
                        Proceed To Pay
                      </llp-button>
                    </div>
                  </div>
                </div>
                <Dialog
                  v-model:visible="showBankModal"
                  :header="bankModalHeader"
                  modal
                  :style="{ width: '90%', maxWidth: '45rem' }"
                  :breakpoints="{ '960px': '75vw', '641px': '90vw' }"
                >
                  <div v-if="beneficiarySpinner" class="loader-overlay">
                    <div class="spinner"></div>
                  </div>
                  <div v-if="showExistingBankList">
                    <h6 class="fw-bold">Your Saved Bank Accounts:</h6>
<div
  v-for="(bank, index) in bankDetails"
  :key="index"
  class="d-flex align-items-center justify-content-between p-2 mb-2 border rounded"
  @click="selectBank(bank)"
  style="cursor: pointer"
  :class="{
    'border-primary bg-light': selectedBankDetails && 
                              selectedBankDetails.bank_account_number === bank.bank_account_number
  }"
>
  <div>
    <p class="fw-bold mb-0">{{ bank.bank_name || 'Bank Account' }}</p>
    <p class="text-muted mb-0">
      ****{{ bank.bank_account_number.slice(-4) }} | {{ bank.bank_ifsc }}
    </p>
  </div>
  <i
    v-if="selectedBankDetails && 
          selectedBankDetails.bank_account_number === bank.bank_account_number"
    class="fas fa-check-circle text-success"
  ></i>
</div>
                    <div class="col-lg-4 col-md-6 col-sm-12">
                      <llp-button
                        classNames="btn-secondary text-white mt-3"
                        @click="addNewBankDetails()"
                      >
                        Add New Bank Details
                      </llp-button>
                    </div>
                  </div>
                  <div class="row ms-2" v-if="addingBankDetails">
                    <form
                      ref="bankdetailsForm"
                      class="d-grid md-m-2"
                      @submit.prevent="addBankDetails"
                    >
                      <div class="row">
                        <div class="col-lg-5 col-md-6 col-sm-12 mb-2">
                          <llp-label id="pincodeLabel" :aria-label="number"
                            >Account Number:</llp-label
                          >
                          <llp-input
                            id="acountNumberId"
                            class="w-100"
                            autocomplete="off"
                            v-model="accountNumber"
                            :errors="validatorBank.accountNumber.$errors"
                          ></llp-input>
                        </div>
                        <div class="col-lg-5 col-md-6 col-sm-12 mb-2">
                          <llp-label id="IFSCCodeLabel" :aria-label="ifscCode"
                            >IFSC Code:</llp-label
                          >
                          <llp-input
                            id="ifscCodeInput"
                            v-model="ifscCode"
                            class="w-100"
                            autocomplete="off"
                            :errors="validatorBank.ifscCode.$errors"
                            placeholder="Enter IFSC code"
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-5 col-md-6 col-sm-12 mb-2">
                          <llp-label id="pincodeLabel" :aria-label="name"
                            >Account Holder Name:</llp-label
                          >
                          <llp-input
                            id="accountName"
                            class="w-100"
                            autocomplete="off"
                            v-model="accountHolderName"
                            :errors="validatorBank.accountHolderName.$errors"
                          ></llp-input>
                        </div>
                      </div>

                      <div class="col-lg-4 col-md-6 col-sm-12">
                        <llp-button
                          classNames="btn-secondary text-white new-btn"
                          type="submit"
                          :loadSpinner="showAddBankDetailsSpinner"
                          >Add Bank Details</llp-button
                        >
                      </div>
                    </form>
                  </div>
                </Dialog>
                <Dialog
                  v-model:visible="showUPI"
                  :header="upiModalHeader"
                  modal
                  :style="{ width: '90%', maxWidth: '45rem' }"
                  :breakpoints="{ '960px': '75vw', '641px': '90vw' }"
                >
                  <div v-if="beneficiarySpinner" class="loader-overlay">
                    <div class="spinner"></div>
                  </div>
                  <div v-if="showExistingUpiList">
                    <h6 class="fw-bold">Your Saved UPI IDs:</h6>
                    <div
  v-for="(upi, index) in upiDetails"
  :key="index"
  class="d-flex align-items-center justify-content-between p-2 mb-2 border rounded"
  @click="selectUpi(upi)"
  style="cursor: pointer"
  :class="{
    'border-primary bg-light': selectedUpiDetails && 
                              selectedUpiDetails.vpa === upi.vpa
  }"
>
  <div>
    <p class="fw-bold mb-0">{{ upi.beneficiary_name || 'UPI ID' }}</p>
    <p class="text-muted mb-0">{{ upi.vpa }}</p>
  </div>
  <i
    v-if="selectedUpiDetails && 
          selectedUpiDetails.vpa === upi.vpa"
    class="fas fa-check-circle text-success"
  ></i>
</div>
                    <div class="col-lg-4 col-md-6 col-sm-12">
                      <llp-button
                        classNames="btn-secondary text-white mt-3"
                        @click="addNewUpi()"
                      >
                        Add New UPI ID
                      </llp-button>
                    </div>
                  </div>
                  <div class="row ms-2" v-if="addBeneficiaryDetails">
                    <p>
                      You can send or request money to the upi id of your
                      contact.The name of the contact is returned on successful
                      verification of the upi id
                    </p>

                    <form
                      ref="loginForm"
                      class="d-grid md-m-2"
                      @submit.prevent="SaveUpiDetails"
                    >
                      <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6 mt-1">
                          <llp-label id="benificiaryId" :aria-label="Branch"
                            >Beneficiary UPI ID:</llp-label
                          >
                          <llp-input
                            id="beneficiaryInput"
                            v-model="beneficiary"
                            class="w-100"
                            autocomplete="off"
                            :errors="validtorBeneficiaryUpi.beneficiary.$errors"
                          ></llp-input>
                        </div>
                      </div>
                      <div v-if="verifiedBeneficiaryName" class="mt-3 ms-2">
                      <!-- <p class="fw-bold">
                         Beneficiary Name: {{ verifiedBeneficiaryName }}
                        </p> -->
                      </div>
                      <p v-if="upiErrorMessage" class="text-danger mt-2">
                        {{ upiErrorMessage }}
                      </p>
                      <div class="col-lg-6 col-md-6 col-sm-6 mt-2">
                        <llp-label id="nicknameId" aria-label="Nickname">
                          Nickname:
                        </llp-label>
                        <llp-input
                          id="nicknameInput"
                          v-model="beneficiaryName"
                          class="w-100"
                          autocomplete="off"
                          :errors="
                            validtorBeneficiaryUpi.beneficiaryName.$errors
                          "
                        ></llp-input>
                      </div>

                      <div class="col-lg-3 col-md-6 col-sm-12">
                        <llp-button
                          classNames="btn-secondary text-white new-btn"
                          type="submit"
                          :loadSpinner="showBeficiarySpinner"
                          @click="SaveUpiDetails()"
                          >Save</llp-button
                        >
                      </div>
                    </form>
                  </div>
                </Dialog>

                <!-- pan verification -->
                <Dialog
                  v-model:visible="panVerification"
                  header="Verify Pan Details"
                  modal
                  :style="{ width: '90%', maxWidth: '45rem' }"
                  :breakpoints="{ '960px': '75vw', '641px': '90vw' }"
                >
                  <div>
                    <form>
                      <div class="row">
                        <div class="col-lg-5 col-md-6 col-sm-12 mb-2">
                          <llp-label id="panNum" :aria-label="panNumber"
                            >Pan Number:</llp-label
                          >
                          <llp-input
                            id="panNumberId"
                            class="w-100"
                            autocomplete="off"
                            v-model="panNumber"
                            :errors="validatorPanCard.panNumber.$errors"
                          ></llp-input>
                          <p class="add-name">
                            Pan number should be like (ABCDE1234F)
                          </p>
                        </div>
                        <div class="col-lg-5 col-md-6 col-sm-12 mb-2">
                          <llp-label
                            id="AccountName"
                            :aria-label="AccountNameLabel"
                            >Add Name:</llp-label
                          >
                          <llp-input
                            id="accountHolderName"
                            class="w-100"
                            autocomplete="off"
                            v-model="addName"
                            :errors="validatorPanCard.addName.$errors"
                          ></llp-input>
                          <p class="add-name">
                            Name must match with name on verified bank account.
                          </p>
                        </div>
                      </div>
                      <div class="col-lg-3 col-md-3 col-sm-12">
                        <llp-button
                          classNames="btn-secondary text-white new-btn"
                          :loadSpinner="showPanVerificationSpinner"
                          @click="proccedPanVerification()"
                          >Proceed</llp-button
                        >
                      </div>
                    </form>
                  </div>
                </Dialog>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import { reactive, toRefs, nextTick } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
import Dialog from "primevue/dialog";
import NetworkService from "@/services/network.service";
import ErrorService from "../../../services/error.service";
import _ from "lodash";

export default {
  components: {
    Dialog,
  },
  setup() {
    const state = reactive({
      amount: "",
      name: "",
      accountNumber: "",
      ifscCode: "",
      accountHolderName: "",
      beneficiary: "",
      beneficiaryName: "",
      panNumber: "",
      addName: "",
    });

    const payamountValidation = {
      amount: {
        required: helpers.withMessage("Amount is required.", required),
         numericOnly: helpers.withMessage(
    "Amount must be a valid number.",
    (value) => /^(\d+(\.\d{1,2})?)$/.test(value)
  ),
      },
      name: {
        required: helpers.withMessage("Name is required.", required),
         alphaOnly: helpers.withMessage(
        "Name should contain only characters.",
        (value) => /^[A-Za-z\s]+$/.test(value)
      ),
      },
    };
    const beneficiaryUpiValidation = {
      beneficiary: {
        required: helpers.withMessage(
          "Beneficiary upi id is required.",
          required
        ),
      },
      beneficiaryName: {
        required: helpers.withMessage("Name is required.", required),
         alphaOnly: helpers.withMessage(
        "Name should contain only characters.",
        (value) => /^[A-Za-z\s]+$/.test(value)
      ),
      },
    };
    const bankdetailsValidation = {
      accountNumber: {
        required: helpers.withMessage("Account number is required.", required),
        numericOnly: helpers.withMessage(
      "Account number should contain only numbers.",
      (value) => /^\d+$/.test(value) 
    ),
      },
      ifscCode: {
        required: helpers.withMessage("IFSC code is required.", required),
         alphanumeric: helpers.withMessage(
      "IFSC code should contain only letters and numbers.",
      (value) => /^[A-Za-z0-9]+$/.test(value)
    ),
      },
      accountHolderName: {
        required: helpers.withMessage(
          "Account holder name is required.",
          required
        ),
         alphaOnly: helpers.withMessage(
        "Account holder name should contain only characters.",
        (value) => /^[A-Za-z\s]+$/.test(value)
      ),
      },
    };
    const panValidation = {
      panNumber: {
        required: helpers.withMessage("Pan number is required.", required),
          validPAN: helpers.withMessage(
          "PAN must be in format(e.g., ABCDE1234F)",
          (value) =>
            value ? /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(value.toUpperCase()) : true
        ),
      },
      addName: {
        required: helpers.withMessage("Name is required.", required),
         alphaOnly: helpers.withMessage(
        "Name should contain only characters.",
        (value) => /^[A-Za-z\s]+$/.test(value)
      ),
      },
    };
    return {
      ...toRefs(state),
      validatorPayment: useVuelidate(payamountValidation, state),
      validatorBank: useVuelidate(bankdetailsValidation, state),
      validtorBeneficiaryUpi: useVuelidate(beneficiaryUpiValidation, state),
      validatorPanCard: useVuelidate(panValidation, state),
    };
  },
  created() {
    this.debouncedFetchCharges = _.debounce(this.fetchPaymentCharges, 500);
  },
  watch: {
    beneficiary(newVal) {
      const upiPattern = /^[a-zA-Z0-9.\-_]{2,50}@ybl$/;
      this.verify = upiPattern.test(newVal.trim());
    },
    // amount(newVal) {
    //   if (newVal && this.selectedPaymentMethod) {
    //     this.debouncedFetchCharges(this.selectedPaymentMethod);
    //   }
    // },
amount(newVal) {
  const isNumericOrFloat = /^(\d+)?(\.\d{0,4})?$/.test(newVal);

  if (isNumericOrFloat && newVal !== "") {
    this.invalidAmountShown = false;
    if (this.selectedPaymentMethod) {
      this.debouncedFetchCharges(this.selectedPaymentMethod);
    }
  } else if (newVal && !isNumericOrFloat) {
    this.paymentCharges = null;
    if (!this.invalidAmountShown) {
      this.$refs.toast?.show("Please enter a valid amount.", "error");
      this.invalidAmountShown = true;
    }
  }
},

    selectedPaymentMethod(newMethod) {
      if (newMethod && this.amount) {
        this.debouncedFetchCharges(newMethod);
      }
    },
    panVerification(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.resetPanForm();
        });
      }
    }
  },
  data() {
    return {
      showaddadminSpinner: false,
      showBankModal: false,
      showLoginSpinner: false,
      showBeficiarySpinner: false,
      showAddBankDetailsSpinner: false,
      loading: false,
      bankData: [],
      canPayWithCard: false,
      showUPI: false,
      showContactModal: false,
      saveUpiId: true,
      verify: false,
      verifiedBeneficiaryName: "",
      addBeneficiaryDetails: false,
      addingBankDetails: false,
      showNicknameField: false,
      showVerifySpinner: false,
      upiErrorMessage: "",
      isUpiVerified: false,
      verifiedUser: "",
      paymentMethods: true,
      selectedBankDetails: null,
      selectedPaymentMethod: null,
      upiDetails: [],
      bankDetails: [],
      paymentCharges: null,
      beneficiarySpinner: false,
      user_id: localStorage.getItem("User_id"),
        role_id:localStorage.getItem('role_id'),
      verifiedBankUser: false,
      showExistingUpiList: false,
      showExistingBankList: false,
      panVerification: false,
      isNewBeneficiary: false,
      currentBeneficiaryId: null,
      beneficiary_id: "",
      id: '',
      showPanVerificationSpinner: false,
      invalidAmountShown: false,
      currentPaymentType: null,
      isAddingNewUpi: false,
      isAddingNewBank: false,
      verifiedBankSummary: {
        accountLastFourDigits: "",
        name: "",
      },
    };
  },
  mounted() {
    const script = document.createElement("script");
    script.src = "https://sdk.cashfree.com/js/v3/cashfree.js";
    script.async = true;
    document.head.appendChild(script);
  },
  computed: {
    upiModalHeader() {
      if (this.beneficiarySpinner) return "Loading...";
      if (this.isAddingNewUpi) return "Add UPI ID";
      return this.upiDetails.length ? "Select UPI ID" : "Add UPI ID";
    },
    bankModalHeader() {
      if (this.beneficiarySpinner) return "Loading...";
      if (this.isAddingNewBank) return "Add Bank Details";
      return this.bankDetails.length
        ? "Select Bank Details"
        : "Add Bank Details";
    },
    selectedPaymentMethodId() {
      if (this.selectedBankDetails) return 1;
      if (this.selectedUpiDetails) return 3;
      return null;
    },
  },
  methods: {
    resetPanForm() {
      this.panNumber = "";
      this.addName = "";
      this.validatorPanCard.$reset();
    },
    BackToServices() {
      this.$router.push("/services");
    },
    async fetchPaymentCharges(methodValue) {
      if (!methodValue || !this.amount) {
        return;
      }
      this.loadingCharges = true;
      this.paymentCharges = null;
      try {
        const baseAmount = parseFloat(this.amount);
        this.paymentCharges = await NetworkService.getPaymentCharges(
          this.selectedPaymentMethodId,this.role_id,
          {
            user_id: this.user_id,
            method_type: methodValue,
            base_amount: baseAmount,
          }
        );
        if (!this.paymentCharges) {
          throw new Error("No charges data received");
        }
      } catch (error) {
        this.$refs.toast.show("Failed to fetch payment charges", "error");
      } finally {
        this.loadingCharges = false;
      }
    },
    async addBankDetails() {
      const isValid = await this.validatorBank.$validate();
      if (!isValid) return;
      this.showAddBankDetailsSpinner = true;

      try {
        const requestData = {
          user_id: this.user_id,
          bank_account_number: this.accountNumber,
          bank_ifsc: this.ifscCode,
          beneficiary_type: "bank",
          beneficiary_name: this.accountHolderName,
        };
        const responseData = await NetworkService.post(
          "create-beneficiary-for-creditcard",
          requestData
        );
        this.isNewBeneficiary = true;
        this.id = responseData.data.id;
        this.$refs.toast.show(responseData.data.message);
        this.accountNumber = "";
        this.ifscCode = "";
        this.accountHolderName = "";
        this.validatorBank.$reset();
        this.showBankModal = false;
        this.verifiedBankUser = false;
        this.verifiedBankSummary.accountLastFourDigits =
          this.accountNumber.slice(-4);
        this.verifiedBankSummary.name = this.accountHolderName;
        this.selectedBankDetails = {
          bank_account_number: this.accountNumber,
          bank_ifsc: this.ifscCode,
          beneficiary_id: responseData.data?.beneficiary_id,
          beneficiary_name: this.accountHolderName,
        };
        this.currentPaymentType = "bank";
        this.panVerification = true;
        this.paymentMethods = true;
      } catch (error) {
        this.$refs.toast.show(ErrorService.getErrorMessages(error), "error");
      } finally {
        this.showAddBankDetailsSpinner = false;
      }
    },

    async SaveUpiDetails() {
      this.panNumber = "";
      this.addName = "";
      const isValid = await this.validtorBeneficiaryUpi.$validate();
      if (!isValid) {
        return;
      }
      this.showBeficiarySpinner = true;
      try {
        const payload = {
          user_id: this.user_id,
          beneficiary_name: this.beneficiaryName?.trim(),
          vpa: this.beneficiary.trim(),
          beneficiary_type: "vpa",
        };
console.log("payload....... line 684....",payload);

        const response = await NetworkService.post(
          "create-beneficiary-for-creditcard",
          payload
        );
        this.isNewBeneficiary = true;
        this.id = response.data.id;
        this.verifiedBeneficiaryName =
          response.data?.beneficiary_name || this.beneficiary;
        this.verifiedUser = this.verifiedBeneficiaryName;
        this.currentPaymentType = "vpa";
        this.paymentMethods = true;
        this.showUPI = false;
        this.panVerification = true;
        this.$refs.toast.show(response.data.message, "success");
        this.selectedUpiDetails = {
  vpa: payload.vpa,
  beneficiary_name: payload.beneficiary_name
};
        this.beneficiaryName = "";
        this.beneficiary =""
        this.validtorBeneficiaryUpi.$reset();
      } catch (error) {
        this.upiErrorMessage =
          ErrorService.getErrorMessages(error) || "Failed to save UPI ID.";
      } finally {
        this.showBeficiarySpinner = false;
      }
    },

    async PaywithCreditCard() {
      if (!this.canPayWithCard) {
        this.$refs.toast.show(
          "Please select a payment method before proceeding.",
          "error"
        );
        return;
      }
      const isValid = await this.validatorPayment.$validate();
      if (!isValid) return;
      this.showLoginSpinner = true;
      const payload = {
        user_id: this.user_id,
        base_amount: this.amount,
        name: this.name,
        beneficiary_type: this.selectedBankDetails ? "bank" : "vpa",
        method_type: this.selectedPaymentMethod,
        charge_amount: this.paymentCharges.charge_amount,
        amount: this.paymentCharges.total_payable,
        charge_percent: this.paymentCharges.charge_percent,
      };
      if (this.selectedBankDetails) {
        payload.bank_account_number =
          this.selectedBankDetails.bank_account_number;
        payload.bank_ifsc = this.selectedBankDetails.bank_ifsc;
      } else if (this.selectedUpiDetails) {
        payload.vpa = this.selectedUpiDetails.vpa;
      } else if (this.beneficiary) {
        payload.vpa = this.beneficiary;
      }
      try {
        const response = await NetworkService.post(
          "pay-creditcard-bill-using-beneficiary",
          payload
        );
        const result = response?.data?.data;
        
        if (result?.payment_session_id && result.order_id) {
          this.$refs.toast.show(response.data.message, "success");
          await this.startCashfreeCheckout(
            result.payment_session_id,
            result.order_id
          );
        } else {
          throw new Error("No payment session ID received from server");
        }
      } catch (error) {
        console.error("Payment error:", error);
        this.$refs.toast.show(
          "Failed to process payment. Please try again.",
          "error"
        );
      } finally {
        this.showLoginSpinner = false;
      }
    },
    async startCashfreeCheckout(paymentSessionId, orderId) {
      if (!window.Cashfree) {
        this.$refs.toast.show("Cashfree SDK not loaded", "error");
        return false;
      }

      const cashfree = window.Cashfree({ mode: "sandbox" });

      try {
        const result = await cashfree.checkout({
          paymentSessionId,
          redirectTarget: "_modal",
        });

        this.showLoginSpinner = false;
        const message = result.paymentDetails.paymentMessage;

        if (message.includes("finished")) {
          try {
            this.loading = true;
            setTimeout(async () => {
              await this.verifyPaymentStatus(orderId);
            }, 5000);
          } catch (err) {
            this.showLoginSpinner = false;
            this.$refs.toast.show("Failed to fetch payment status", "error");
          }
        }
        return true;
      } catch (error) {
         this.showLoginSpinner = false;
    if (this.$refs.toast) {
      this.$refs.toast.show(
        "An error occurred during payment. Please try again.",
        "error"
      );
    }
    setTimeout(() => {
      this.$router.back();
    }, 3000);
    return false;
  }
    },
    async verifyPaymentStatus(orderId) {
      await NetworkService.PaymentService.verifyAndHandlePaymentStatus(orderId, this);
    },
   
    async showUPIModal() {
      this.showUPI = true;
      this.isAddingNewUpi = false;
      this.beneficiarySpinner = true;
      this.addBeneficiaryDetails = false;
      this.showExistingUpiList = false;
      this.upiDetails = [];

      try {
        await this.fetchBeneficiaryDetails("vpa");
        if (this.upiDetails.length > 0) {
          this.showExistingUpiList = true;
          this.addBeneficiaryDetails = false;
        } else {
          this.addBeneficiaryDetails = true;
          this.isUpiVerified = false;
          this.canPayWithCard = false;
          this.paymentMethods = true;
          this.beneficiary = "";
          this.beneficiaryName = "";
        }
      } catch (error) {
        this.upiDetails = [];
        this.addBeneficiaryDetails = true;
        this.isUpiVerified = false;
        this.canPayWithCard = false;
      } finally {
        this.beneficiarySpinner = false;
      }
    },
    async showBankModalDialog() {
      this.showBankModal = true;
      this.isAddingNewBank = false;
      this.showExistingBankList = false;
      this.addingBankDetails = false;
      this.bankDetails = [];
      this.beneficiarySpinner = true;
      try {
        await this.fetchBeneficiaryDetails("bank");
        if (this.bankDetails.length > 0) {
          this.showExistingBankList = true;
          this.addingBankDetails = false;
        } else {
          this.bankDetails = [];
          this.addingBankDetails = true;
          this.canPayWithCard = false;
        }
      } catch (error) {
        this.bankDetails = [];
        this.canPayWithCard = false;
      } finally {
        this.beneficiarySpinner = false;
      }
    },
   
    async selectBank(bank) {
      if (this.selectedBankDetails && 
          this.selectedBankDetails.bank_account_number === bank.bank_account_number) {
        return;
      }
      this.selectedBankDetails = null;
      this.verifiedBankUser = false;
      this.selectedBankDetails = bank;
      this.selectedPaymentMethod = "Net Banking";
      this.currentPaymentType = "bank";
      this.currentBeneficiaryId = bank.id; 
      this.isNewBeneficiary = false;
      try {
        const selectedBankResponse = await NetworkService.get(
          `get-pan-verification-status/${bank.id}`
        );
        
        if (selectedBankResponse.status == true) {
          this.showBankModal = false;
          this.verifiedBankSummary = {
            accountLastFourDigits: bank.bank_account_number?.slice(-4),
            name: bank.beneficiary_name || ""
          };
          this.verifiedBankUser = true;
          this.paymentMethods = false;
          this.canPayWithCard = true;
          
          if (this.amount) {
            this.fetchPaymentCharges("Net Banking");
          }
        } else {
          this.panVerification = true;
          this.showBankModal = false;
        }
      } catch (error) {
        this.$refs.toast.show(error, "error");
        this.selectedBankDetails = null;
      }
    },

    async selectUpi(upi) {
      if (this.selectedUpiDetails && this.selectedUpiDetails.vpa === upi.vpa) {
        return;
      }

      this.selectedUpiDetails = null;
      this.isUpiVerified = false;
      this.selectedUpiDetails = upi;
      this.selectedPaymentMethod = "UPI";
      this.currentPaymentType = "vpa";
      this.currentBeneficiaryId = upi.id; 
      this.isNewBeneficiary = false;
      try {
        const selectedUpiResponse = await NetworkService.get(
          `get-pan-verification-status/${upi.id}`
        );
        
        if (selectedUpiResponse.status === true) {
          this.showUPI = false;
          this.verifiedBeneficiaryName = upi.beneficiary_name || upi.vpa;
          this.isUpiVerified = true;
          this.paymentMethods = false;
          this.canPayWithCard = true;
          
          if (this.amount) {
            this.fetchPaymentCharges("UPI");
          }
        } else {
          this.panVerification = true;
          this.showUPI = false;
        }
      } catch (error) {
        this.$refs.toast.show(error, "error");
        this.selectedUpiDetails = null;
      }
    },

    addNewUpi() {
      this.isAddingNewUpi = true;
      this.addBeneficiaryDetails = true;
      this.showExistingUpiList = false;
      this.selectedUpiDetails = null;
    },
    addNewBankDetails() {
      this.isAddingNewBank = true;
      this.addingBankDetails = true;
      this.showExistingBankList = false;
      this.selectedBankDetails = null;
    },
    async fetchBeneficiaryDetails(type) {
      try {
        const payload = {
          beneficiary_type: type,
          user_id: this.user_id,
        };

        const response = await NetworkService.get(
          "get-beneficiary-upis-for-creditcard",
          payload
        );

        if (type === "vpa") {
          this.upiDetails = response?.beneficiaries || [];
        } else if (type === "bank") {
          this.bankDetails = response?.beneficiaries || [];
        }
      } catch (error) {
        this.$refs.toast.show(
          `Unable to fetch ${type === "vpa" ? "UPI" : "bank"} details`,
          "error"
        );
      }
    },

    async proccedPanVerification() {
      await nextTick();
      this.validatorPanCard.$reset();
      await nextTick();
      
      const isValid = await this.validatorPanCard.$validate();
      if (!isValid) {
        return;
      }

      this.showPanVerificationSpinner = true;
      try {
        const payload = {
          user_id: this.user_id,
          pan: this.panNumber,
          name: this.addName,
        };

        if (this.currentPaymentType === "bank" && this.selectedBankDetails) {
          payload.beneficiary_type = "bank";
          payload.bank_account_number = this.selectedBankDetails.bank_account_number;
          payload.bank_ifsc = this.selectedBankDetails.bank_ifsc;
        } else if (this.currentPaymentType === "vpa") {
          payload.beneficiary_type = "vpa";
          if (this.selectedUpiDetails) {
            payload.vpa = this.selectedUpiDetails.vpa;
          } else if (this.beneficiary) {
            payload.vpa = this.beneficiary;
          } else {
            this.$refs.toast.show("No valid UPI ID found for verification", "error");
            return;
          }
        } else {
          this.$refs.toast.show("Bank details fetching failed", "error");
          return;
        }
        const beneficiaryId = this.isNewBeneficiary ? this.id : this.currentBeneficiaryId;
        const response = await NetworkService.post(
          `pan-verification-for-creditcard-pay/${beneficiaryId}`,
          payload
        );

       if (response.data && response.data.success == true) {
          this.$refs.toast.show(response.data.message, "success");
          if (this.currentPaymentType === "bank") {
            this.verifiedBankUser = true;
            this.paymentMethods = false;
            this.verifiedBankSummary = {
              name: this.addName, 
              accountLastFourDigits: this.selectedBankDetails.bank_account_number.slice(-4)
            };
          } else if (this.currentPaymentType === "vpa") {
            this.isUpiVerified = true;
            this.paymentMethods = false;
            this.verifiedBeneficiaryName = this.addName; 
          }
          
          this.panVerification = false;
          this.canPayWithCard = true;
        } else {
          this.$refs.toast.show(
            response.data[1] || "PAN verification failed",
            "error"
          );
        }
      } catch (error) {
        const errorMessage = error?.message || "Unable to verify the PAN details";
        this.$refs.toast.show(errorMessage, "error");
      } finally {
        this.showPanVerificationSpinner = false;
      }
    },
    
    resetPaymentMethod() {
      this.paymentMethods = true;
      this.verifiedUser = "";
      this.verifiedBeneficiaryName = "";
      this.isUpiVerified = false;
      this.saveUpiId = false;
      this.nickname = "";
      this.beneficiary = "";
      this.beneficiaryName = "";
      this.showNicknameField = false;
      this.upiErrorMessage = "";
      this.canPayWithCard = false;
      this.verifiedBankUser = false;
      this.accountNumber = "";
      this.ifscCode = "";
      this.accountHolderName = "";
      this.amount = "";
      this.name = "";
      this.panNumber = "";
      this.addName = "";
      this.paymentCharges = "";
      this.validatorPayment.$reset();
      this.validatorBank.$reset();
      this.validtorBeneficiaryUpi.$reset();
      this.validatorPanCard.$reset();
      this.selectedBankDetails = null;
      this.selectedUpiDetails = null;
    },
  },
};
</script>